import React  from 'react'

import {FieldViewProps} from "../../../render/view"
import ReactionsList from "../../../../gd-components/reactions/reactions-list/reactions-list";
import Reactions from "../../../../model2/reaction/reactions";

const debug = "FieldReaction_View"
// const debug = false

// something wrong here ?

export default function FieldReaction_View(props:FieldViewProps) {

    debug && console.log(debug, 'render fieldId=', props.field.fieldId, "model=", props.model)

    const value = _.get(props.model, props.field.fieldId, null)

    debug && console.log(debug, '    value=', value)

    const reactions = Reactions.initFromJson(value)

    return <ReactionsList reactions={reactions} toggleReaction={()=>{}} />

}
